module.exports = "<svg viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.355 11.25c-2.588 0-4.688-2.52-4.688-5.625S18.767 0 21.355 0c2.588 0 4.688 2.52 4.688 5.625s-2.1 5.625-4.688 5.625zm-2.673 5.417h5.625c3.105 0 5.625.853 5.625 3.958v6.042h-10V22.5c0-2.65-2.467-4.023-4.932-4.618 1.032-1.244 1.943-1.215 3.682-1.215zm-10.66-2.084c-2.589 0-4.689-2.52-4.689-5.625s2.1-5.625 4.689-5.625c2.588 0 4.688 2.52 4.688 5.625s-2.1 5.625-4.688 5.625zM11.25 20c3.105 0 7.083 1.27 7.083 4.375V30H0v-5.625C0 21.27 2.52 20 5.625 20h5.625z\" fill=\"#000\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/people.svg
// module id = 77
// module chunks = 0